import {
  OPEN_CART,
  CLOSE_CART,
  CLEAR_ITEM_FROM_CART,
  ADD_TO_CART,
  TOTAL_COST,
  UPDATE_CURRENCY,
  CLEAR_CART,
  ADD_CART_ITEM,
  REMOVE_CART_ITEM
} from 'context/constants';

export const openCart = () => ({ type: OPEN_CART });
export const addItem = item => ({ type: ADD_CART_ITEM, payload: item });
export const removeItem = item => ({ type: REMOVE_CART_ITEM, payload: item });
export const addToCart = items => ({ type: ADD_TO_CART, payload: items });
export const closeCart = () => ({ type: CLOSE_CART });
export const totalCost = () => ({ type: TOTAL_COST });

export const updateCurrency = currency => ({
  type: UPDATE_CURRENCY,
  payload: currency
});

export const clearFromCart = item => ({
  type: CLEAR_ITEM_FROM_CART,
  payload: item
});

export const clearCart = () => ({
  type: CLEAR_CART
});
